export default __webpack_public_path__ + "static/media/news2402291.497b3853.png";